/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Studio_Export_RouteInputs */

const en_ui_studio_export_route = /** @type {(inputs: Ui_Studio_Export_RouteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export whole route`)
};

const de_ui_studio_export_route = /** @type {(inputs: Ui_Studio_Export_RouteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganze Strecke exportieren`)
};

/**
* | output |
* | --- |
* | "Export whole route" |
*
* @param {Ui_Studio_Export_RouteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_studio_export_route = /** @type {((inputs?: Ui_Studio_Export_RouteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Studio_Export_RouteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_studio_export_route(inputs)
	return de_ui_studio_export_route(inputs)
});